export const localSeoRoutes = {
  path: "/lawyer",
} as const;
